import type { IconType } from "../icon";

export const pearsonIconMap = {
	account: "person",
	"account-circle": "person",
	"account-circle-outline": "person",
	"arrow-down": "arrow-down",
	"arrow-left": "arrow-left",
	"arrow-right": "arrow-right",
	"arrow-up": "arrow-up",
	brain: "brain",
	calendar: "calendar",
	"calendar-outline": "calendar",
	"chart-line-variant": "chart4",
	"chart-timeline-variant-shimmer": "chart4",
	"check-circle-outline": "tick",
	clipboard: "clipboard",
	"clipboard-outline": "clipboard",
	"clipboard-check": "clipboard",
	"clipboard-check-outline": "clipboard",
	"clipboard-text": "clipboard",
	"clipboard-text-outline": "clipboard",
	cube: "product",
	"help-circle-outline": "question-mark",
	home: "home",
	"home-outline": "home",
	logout: "back-exit",
	magnify: "magnifying-glass",
	menu: "menu",
	"microsoft-xbox-controller-menu": "menu",
	"open-in-new": "new-window",
	pencil: "pencil",
	"pencil-circle": "pencil",
	"pencil-circle-outline": "pencil",
	"pencil-outline": "pencil",
	"plus-circle": "plus",
	"plus-circle-outline": "plus",
	trophy: "medal3",
	"trophy-outline": "medal3",
} as const satisfies Partial<Record<IconType, string>>;
